import LogoutIcon from '@mui/icons-material/Logout';
import PhonelinkLockIcon from '@mui/icons-material/PhonelinkLock';
import React from 'react';
import { AuthContext } from '../contexts/auth-context';
import { SystemIdentity, SystemScreen } from './alliance/system-screen';
import { MfaMethodsCard } from './mfa-methods-card';

/**
 * "Set up multi-factor authentication", Contracting's variant (mfaEmbed in
 * the System Screens spec). The other apps send people here to set it up;
 * Contracting lists the verification methods in the body slot, with a Set
 * up button that opens the Agent Profile's set-up drawer, instead of a "Go
 * to Contracting" button.
 *
 * Saving a method refreshes the gate's MFA check, so the app continues by
 * itself once a method is set.
 *
 * @param identity - "Signed in as" above Sign out
 * @param onSignOut - Sign out (the only action)
 */
export function MfaEmbedScreen(props: {
  identity?: SystemIdentity | null;
  onSignOut: () => void;
}) {
  // Context
  const {
    state: { user },
  } = React.useContext(AuthContext);

  return (
    <SystemScreen
      layout="page"
      tone="info"
      icon={<PhonelinkLockIcon />}
      eyebrow="Security"
      title="Set up multi‑factor authentication"
      body={
        <p>Choose how you’d like to confirm it’s you each time you sign in.</p>
      }
      identity={props.identity}
      secondaryAction={{
        label: 'Sign out',
        icon: <LogoutIcon />,
        onClick: props.onSignOut,
      }}
      help
    >
      {user ? <MfaMethodsCard user={user} /> : null}
    </SystemScreen>
  );
}
